let activeCustomerId = null

export function setActiveChatThreadCustomerId(customerId) {
  activeCustomerId = customerId != null ? customerId.toString() : null
}

export function getActiveChatThreadCustomerId() {
  return activeCustomerId
}
